const download = [
  {
    title: "第一章 神宗夢魘",
    urls: [
      // QEF2019_0632 工作紙1_神宗夢魘（初中）
      [
        "https://docs.google.com/document/d/1NcAd_c8k-RipE4ph8FRKXVrQnYNVT0ixolVXIwoql74/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1MSceksx83Mx4MjDf7W0PxEKaDz-BSEbs/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙1_神宗夢魘（高小）
      [
        "https://docs.google.com/document/d/18Kcsw4JFyqfpq_W4LUpSzbJgPXw-Pz9vtEabqXXJj0w/edit?usp=drivesdk",
        "https://drive.google.com/file/d/15j4A3L4BywMZJgut30p9hgRJbae7KMZ2/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第二章 江寧人家",
    urls: [
      // QEF2019_0632 工作紙2_江寧人家（初中）
      [
        "https://docs.google.com/document/d/144fE1Zp7nyfsRhXU0LYJZz2BzXNdURFVoJ3CvPoyTdA/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1foviKYqkQwKeEXcETj5BbvPAgLEWesSK/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙2_江寧人家（高小）
      [
        "https://docs.google.com/document/d/1SWNxO6892ui-oQHE5E-bnZ7C7FPs5v0byAoaxfRc6vs/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1CmoZ-yEWXuJHREKPP33bXAea0cYF9tcH/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第三章 登基大典",
    urls: [
      // QEF2019_0632 工作紙3_登基大典（初中）
      [
        "https://docs.google.com/document/d/1WbpQvg773c9ZIICb_4ZZ6TevLJQHyNdmtUkHcv07Zq8/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1ND--bgDczckrNsPIbW3JQQXlWJErmT-l/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙3_登基大典（高小）
      [
        "https://docs.google.com/document/d/1j0FfcIHk114-fS62fdq7QYVEbjeiM3Jw2BM6h7aZMSk/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1M93WCOIF_Dkwi8xODOhJg-VzEqpf5k-d/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第四章 介甫辭妾",
    urls: [
      // QEF2019_0632 工作紙4_介甫辭妾（初中）
      [
        "https://docs.google.com/document/d/1e74QEHm1_Ce9YPzS8VJOUxaBt6i9VV6sC0yS0veBqvU/edit?usp=drivesdk",
        "https://drive.google.com/file/d/14j4WItNx-XMcu9T8PzuAP3PzcbnjPSB2/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙4_介甫辭妾（高小）
      [
        "https://docs.google.com/document/d/1CzxS8W08pCbjN0sCtmNWTVd57Pnz6HKhe2CVJoTbxn8/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1lkBhhXWcJyiw1q4NA77Dj8nSci0e7rR3/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第五章 君臣之遇",
    urls: [
      // QEF2019_0632 工作紙5_君臣之遇（初中）
      [
        "https://docs.google.com/document/d/11QsghNgb2RSR0oNw7syqlEsYtkfZFs0-7waJsCzmfSA/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1-XC1c27SVwbnQH3oyGtf9948eXKPk0JS/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙5_君臣之遇（高小）
      [
        "https://docs.google.com/document/d/1GiGr33uI5gtrXs2OmfuNMqtTVg7sC16QaYA070MU6qY/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1AEc-22BK1wqHoKQ4wzxNhUGIh_Cq_JcF/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第六章 新官上任",
    urls: [
      // QEF2019_0632 工作紙6_新官上任（初中）
      [
        "https://docs.google.com/document/d/15_zYl7dzkXK5AM_d-hEzKb1RR-FRZ8fxf0NPkxYpFQY/edit?usp=drivesdk",
        "https://drive.google.com/file/d/16BvMiCZCOwTXX5CnOj2TyDLYYGTmSFFA/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙6_新官上任（高小）
      [
        "https://docs.google.com/document/d/1Brr9429rm4E039x4nxhXbCApc89YIIAIeDGzEB2xeO0/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1bPIkFbHS5hZ__shqnaxr0XxqFyc6dmUI/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第七章 田野風光",
    urls: [
      // QEF2019_0632 工作紙7_田野風光（初中）
      [
        "https://docs.google.com/document/d/1E7XWOiZloAD6-g6R1ws64yKs0guNdwK1sQrY-v62MC4/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1gSMZp3iv5fr_WZtjSIWLTiehqzG2JEhW/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙7_田野風光（高小）
      [
        "https://docs.google.com/document/d/1AklmcCJu6pnLc0iExGTB-b3SKgZzHPz-nMczXhDVpc0/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1HCK4z3Po4RmbOAAvNS9cJ1fNuP2q4Nd7/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第八章 反對勢力",
    urls: [
      // QEF2019_0632 工作紙8_反對勢力（初中）
      [
        "https://docs.google.com/document/d/12ElkLzbx5sBIwzqFMKrowH0aK3cUQkA_ls0xDM_bQY4/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1ekhM2NJ0831bA7zkultp6kBxXI4vxXw2/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙8_反對勢力（高小）
      [
        "https://docs.google.com/document/d/1cyG3rK7OuDAK-yDan8qDAdtKdnvglXd0DtEH0XbfWkU/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1kCYYaewar1VCBcj_HJma74rwbDkIPoX-/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第九章 天災人禍",
    urls: [
      // QEF2019_0632 工作紙9_天災人禍（初中）
      [
        "https://docs.google.com/document/d/196VbhAXB6k9ibVLgOBnffcJmcdc6FOzM0f4CW2yr-GY/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1HxBLUPihtmo4rKoxO8O9KvZbfzd36tJZ/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙9_天災人禍（高小）
      [
        "https://docs.google.com/document/d/1L8OCuWG9YyyO1cxfD0-AqeQrG61_2zgf5FpTbiw_6aU/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1HLO2U6BaV2H61ww4HR1zEL_GwB7pehRM/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第十章 怨聲載道",
    urls: [
      // QEF2019_0632 工作紙10_怨聲載道（初中）
      [
        "https://docs.google.com/document/d/1Ty5GyMCTwWWedAYAXjMpgJyoH2PsaBc_CQYRJXMi6M0/edit?usp=drivesdk",
        "https://drive.google.com/file/d/150ivmEh4Wf-N3t3GrdJMPt_GMoJ06Ui0/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙10_怨聲載道（高小）
      [
        "https://docs.google.com/document/d/1TGGesqa-B4m_D2auREIWZjLYhaV8x2fVB1lpukmDEkw/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1Ufw_0uKdjo5Yd3BJFroGGYIgJbV5btnY/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第十一章 退隱江湖",
    urls: [
      // QEF2019_0632 工作紙11_退隱江湖（初中）
      [
        "https://docs.google.com/document/d/1044NI6BLTTQvTtYaQ3jLVjCqdebSEEz8aHoYfrs-eYg/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1niwKJeNdhOgidKSsJ0ZeYWrQnwOnzN0_/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙11_退隱江湖（高小）
      [
        "https://docs.google.com/document/d/1r_UhHoRNUdDnZR5P7q4X0yl4QZMtAH4XNpwa2bhi9PY/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1Lrgx5mPyfXsOCgzzofYRQPY1bCi6S3_G/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第十二章 風雲變色",
    urls: [
      // QEF2019_0632 工作紙12_風雲變色（初中）
      [
        "https://docs.google.com/document/d/1Syee_YVFp-2C6wsdsKoTIKuvux-pQ7H9f_vqJrJ99_k/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1WR0P5F_4vDvFqamTtJlpVzVG0z_jmGTw/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙12_風雲變色（高小）
      [
        "https://docs.google.com/document/d/1MgxACcqwvDK64WB8hleCAAbDy9XrNtKazPRY1L-iIpc/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1DsEyxNV2XVxZ1FFG5nk9nGp6diFrV89c/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第十三章 以文入獄",
    urls: [
      // QEF2019_0632 工作紙13_以文入獄（初中）
      [
        "https://docs.google.com/document/d/1ZYGMQYLyu-yK2ZlmZa3IkbHecCvE1YQDxWT4t9gLT8I/edit?usp=drivesdk",
        "https://drive.google.com/file/d/12Z4RBjCzJaMZMZET4Pv9VHymMJra5EH7/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙13_以文入獄（高小）
      [
        "https://docs.google.com/document/d/1iMvA51f2Hf6CHFJC_s7Vh3NNbgJem1g8QblWA7-Npyg/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1Mj1FGcz5za_spZhTQrGVC5EMaZ61ngby/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第十四章 落魄歸途、第十五章 愛兒溟逝",
    urls: [
      // QEF2019_0632 工作紙14_15_落魄歸途_愛兒溟逝（初中）
      [
        "https://docs.google.com/document/d/1Ot53Vz_WT8_GlvlZHP_JLWn8JxjDtx4G7W1MPHYLkzQ/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1THu_sjOewlyM-mdze-OSAYAH_uy5fleV/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙14_15_落魄歸途_愛兒溟逝（高小）
      [
        "https://docs.google.com/document/d/1gwmLueXTINxxGsBxGVMT6FJDiQgSyPYPfnjIHiLkioA/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1sCm-dqjuA0_yNsxl3cUlY3dRk_831Msb/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "第十六章 刀下留人",
    urls: [
      // QEF2019_0632 工作紙16_刀下留人（初中）
      [
        "https://docs.google.com/document/d/1THd4uBUU8XthqkxuTzwGBf1yQiG1nmQzcpPG-jFbiAg/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1OhvNHNcVodrBfceGxE9DAS-GWwENdGWQ/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙16_刀下留人（高小）
      [
        "https://docs.google.com/document/d/1B_U9-7Vodbsp4eL_e4xDgbLSifS0F2W8dd2mkRpcQNI/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1V8yO_p15nm6BH_omjYU7UqHgCEoSHj5Z/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "後記",
    urls: [
      // QEF2019_0632 工作紙_後記（初中）
      [
        "https://docs.google.com/document/d/1y5Fqi97P07PMSae8qLJbjR7rMq8n95xsZKSjMH0piW8/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1bpOeMPsogFokG5r0Rw_bYMeQvn_y-YRI/view?usp=drivesdk",
      ],

      // QEF2019_0632 工作紙_後記（高小）
      [
        "https://docs.google.com/document/d/1_6-c1bQrA8izZaCD_PHE0bH5EiIgNHcRG4NYb5vF9Nk/edit?usp=drivesdk",
        "https://drive.google.com/file/d/1FeudTZASmchRrdc7qwFIXDR0AJygVStK/view?usp=drivesdk",
      ],
    ],
    types: ["docx", "pdf"],
  },
  {
    title: "工作紙參考答案",
    urls: [
      // 《細說王安石》工作紙參考答案（初中適用）.pdf
      [
        "https://drive.google.com/file/d/1ojneAdm6JsOMOnXy49YfUp4Jn7ARngtM/view?usp=drivesdk",
      ],

      // 《細說王安石》工作紙參考答案（高小適用）.pdf
      [
        "https://drive.google.com/file/d/1awjPqmvnZLLPcmVsoDCdSPD5Nqrk8yQ3/view?usp=drivesdk",
      ],
    ],
    types: ["pdf"],
  },
];

export default download;
